import axios from 'axios';
import {BASE_URL, token} from '../utils/const';
import {getLanguage} from 'react-switch-lang';

export const getUsersList = (pageNumber, searchData) => {
  const searchTerm =
    searchData !== undefined && searchData.length > 0
      ? `&searchTerm=${searchData}`
      : '';
  return axios({
    method: 'GET',
    url: `${BASE_URL}/users?page=${pageNumber}&size=100&sort=firstName${searchTerm}`,
    headers: {
      Authorization: 'Bearer ' + token,
      Accept: '*/*',
    },
  });
};

export const getAllUsers = (pageNumber = 0, size = 20, query= '') => {
  return axios({
    method: 'GET',
    url: `${BASE_URL}/users?page=${pageNumber}&size=${size}&sort=firstName${query ? `&search.contains=${query}` : ''}`,
    headers: {
      Authorization: 'Bearer ' + token,
      Accept: '*/*',
    },
  });
};
export const getAllRiskRelatedUsers = (pageNumber = 0, pageSize = 20) => {
  return axios({
    method: 'GET',
    url: `${BASE_URL}/users/risk-related`,
    params: {
      page: pageNumber,
      pageNumber,
      size: pageSize
    },
    headers: {
      Authorization: 'Bearer ' + token,
      Accept: '*/*',
    },
  });
};




export const createUser = (formData) => {
  return axios({
    method: 'POST',
    url: `${BASE_URL}/users`,
    data: JSON.stringify(formData),
    headers: {
      Authorization: 'Bearer ' + token,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });
};

export const updateUser = (formData) => {
  return axios({
    method: 'PUT',
    url: `${BASE_URL}/users`,
    data: formData,
    headers: {
      Authorization: 'Bearer ' + token,
      Accept: '*/*',
      'Content-Type': 'application/json',
    },
  });
};


export const getRoles = (data, setRoleFunction) => {
  return axios
    .get(`${BASE_URL}/users/authorities`,{
      headers: {
        Authorization: 'Bearer ' + token,
      },
    })
    .then((r) => {
      const roles = [];
      const result = [];
      data.map((item) => {
        roles.push(r.data.find((a) => a.name === item));
      });
      roles.map((role) =>
        result.push({
          label: getLanguage() === 'mne' ? role.description : role.name,
          value: role.name,
        })
      );
      setRoleFunction(result);
    })
    .catch((r) => {});
};


export const deactivateUser = (userID) => {
  return axios({
    method: 'PUT',
    url: `${BASE_URL}/users/${userID}/change-user-activation`,
    headers: {
      Authorization: 'Bearer ' + token,
      Accept: '*/*',
    },
  });
};

